import {put} from '../utils'

export default host => albumId => put(`${host}/albums/${albumId}/review`)
